import { render, staticRenderFns } from "./MuestraComunicadosModal.vue?vue&type=template&id=58fc8992&"
import script from "./MuestraComunicadosModal.vue?vue&type=script&lang=js&"
export * from "./MuestraComunicadosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports